import { Typography } from '@mui/material';
import { pickBy } from 'lodash';
import queryString from 'query-string';
import RouterLinkNoUnderline from 'src/components/common/RouterLinkNoUnderline';
import { WITHHELD_GOVERNMENT_COMPANY_NAME } from 'src/utils/constants/config';
import { TypeBuyerSupplier } from 'src/utils/constants/enum';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import { ISearchGlobalTradeDataQueryParams } from 'src/utils/typings/dto/tradeData';
interface ILinkToCompanyDetailProps {
  id?: string;
  companyName?: string;
  params?: ISearchGlobalTradeDataQueryParams | IForwardedParamsCompanyDetailLink;
  viewedAsType?: TypeBuyerSupplier;
}

export interface IForwardedParamsCompanyDetailLink {
  start_date?: string;
  end_date?: string;
  viewedAsType?: TypeBuyerSupplier;
}

const LinkToCompanyDetail = (props: ILinkToCompanyDetailProps) => {
  const { id, params, viewedAsType, companyName } = props;
  const forwardedParams: IForwardedParamsCompanyDetailLink = pickBy(
    {
      start_date: params?.start_date,
      end_date: params?.end_date,
      viewedAsType: viewedAsType,
    },
    Boolean,
  );

  const query = '?' + queryString.stringify(forwardedParams);
  if (companyName?.includes(WITHHELD_GOVERNMENT_COMPANY_NAME) || !id) {
    return <Typography variant="body2">{renderTextOrDefault(companyName)}</Typography>;
  }
  return (
    <RouterLinkNoUnderline to={AuthRouteKeys.CompanyDetail.replace(':id?', id || '') + query}>
      <Typography variant="body2" color="secondary">
        {renderTextOrDefault(companyName)}
      </Typography>
    </RouterLinkNoUnderline>
  );
};

export default LinkToCompanyDetail;
